import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Heading,
  Card,
  CardHeader,
  CardBody,
} from "@chakra-ui/react";
export default function Faq() {
  return (
    <Card
      className="faq-container"
      id="faq"
      bg="rgba(248, 249, 250, 1)"
      borderRadius="lg"
      boxShadow="lg"
      p={0}
      w={{ sm: "90%", "2xl": "50%" }}
      mx="auto"
    >
      <CardHeader>
        <Heading
          textAlign="center"
          as="h1"
          size={{ "2xl": "xl", lg: "xl" }}
          color="#C9342D"
        >
          Često postavljana pitanja
        </Heading>
      </CardHeader>
      <CardBody>
        <Accordion allowToggle height="100%">
          <AccordionItem className="faq-item">
            <h2>
              <AccordionButton
                display="flex"
                alignItems="center"
                height="100%"
                py={4}
                px={6}
                borderTop="2px solid #e2e8f0"
                borderRadius="md"
              >
                <Box as="span" flex="1" textAlign="left" height="100%">
                  Koji lični podaci se traže od zaposlenih?
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              Zahtevamo njihov pozdrav (gospodin/gospođa), poslovnu imejl
              adresu, jezik i (opciono) dodeljivanje u korisničku grupu. Ako je
              data grupa korisnika.
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem className="faq-item">
            <h2>
              <AccordionButton
                display="flex"
                alignItems="center"
                height="100%"
                py={4}
                px={6}
                borderTop="2px solid #e2e8f0"
                borderRadius="md"
              >
                <Box as="span" flex="1" textAlign="left">
                  Kako SafeCrafts dobija podatke o zaposlenima?
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              Predstavnik klijenta dobija pristup SafeCrafts administratorskoj
              roli. Da bi se ispravno podesio trening neophodne informacije je
              potrebno uneti, ili povezati SSO preko Microsoft Azure Active
              Directory.
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem className="faq-item">
            <h2>
              <AccordionButton
                display="flex"
                alignItems="center"
                height="100%"
                py={4}
                px={6}
                borderTop="2px solid #e2e8f0"
                borderRadius="md"
              >
                <Box as="span" flex="1" textAlign="left">
                  Koliko dugo se čuvaju podaci o zaposlenima?
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              Podaci se čuvaju tokom trajanja obrade na osnovu porudžbine.
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem className="faq-item">
            <h2>
              <AccordionButton
                display="flex"
                alignItems="center"
                height="100%"
                py={4}
                px={6}
                borderTop="2px solid #e2e8f0"
                borderRadius="md"
              >
                <Box as="span" flex="1" textAlign="left">
                  Da li se stopa klikova može pripisati pojedinačnim zaposlenima
                  u simulaciji fišinga?
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              Ne. Uzeli smo u obzir zaštitu podataka prilikom projektovanja
              naših tehničkih sistema.
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem className="faq-item">
            <h2>
              <AccordionButton
                display="flex"
                alignItems="center"
                height="100%"
                py={4}
                px={6}
                borderTop="2px solid #e2e8f0"
                borderRadius="md"
              >
                <Box as="span" flex="1" textAlign="left">
                  Da li zaposleni treba da budu obavešteni o simulaciji fišinga
                  pre njenog početka?
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              Najava obuke unapred dovodi do mnogo pozitivnije reakcije među
              zaposlenima. Na ovaj način, niko se ne oseća kao da je iznenada
              testiran i biće prijemčiviji za obuku.
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </CardBody>
    </Card>
  );
}
